(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clinically-proven-result"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSliders() {
      const sliders = document.querySelectorAll('[data-slider]');
      if (!sliders.length) return;

      sliders.forEach(slider => {
        let isDown = false;
        const beforeWrapper = slider.querySelector('[data-before-wrapper]');
        const divider = slider.querySelector('[data-divider]');
        const handle = slider.querySelector('[data-handle]');
        if (!beforeWrapper || !divider || !handle) return;

        function updateSlider(clientX) {
          const rect = slider.getBoundingClientRect();
          if (rect.width <= 0) return;
          var pct = ((clientX - rect.left) / rect.width) * 100;
          if (pct !== pct) return;
          var percentage = Math.max(0, Math.min(100, pct));
          beforeWrapper.style.clipPath = 'inset(0 ' + (100 - percentage) + '% 0 0)';
          divider.style.left = percentage + '%';
          handle.style.left = percentage + '%';
        }

        function getCenterX() {
          const rect = slider.getBoundingClientRect();
          return rect.left + rect.width / 2;
        }

        function isInside(clientX) {
          const rect = slider.getBoundingClientRect();
          return clientX >= rect.left && clientX <= rect.right;
        }

        function initPosition() {
          var cx = getCenterX();
          var rect = slider.getBoundingClientRect();
          if (rect.width > 0) updateSlider(cx);
        }

        requestAnimationFrame(initPosition);

        slider.addEventListener('mousedown', function(e) {
          e.preventDefault();
          e.stopPropagation();
          isDown = true;
          slider.classList.add('dragging');
          handle.classList.add('dragging');
          if (isInside(e.clientX)) updateSlider(e.clientX);
        }, false);

        document.addEventListener('mouseup', function() {
          isDown = false;
          slider.classList.remove('dragging');
          handle.classList.remove('dragging');
        }, false);

        slider.addEventListener('mousemove', function(e) {
          if (!isDown) return;
          if (isInside(e.clientX)) updateSlider(e.clientX);
        }, false);

        slider.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (isInside(e.clientX)) updateSlider(e.clientX);
        }, false);

        slider.addEventListener('touchstart', function(e) {
          isDown = true;
          slider.classList.add('dragging');
          if (e.touches[0] && isInside(e.touches[0].clientX)) {
            updateSlider(e.touches[0].clientX);
          }
        }, { passive: true });

        document.addEventListener('touchend', function() {
          isDown = false;
          slider.classList.remove('dragging');
        }, false);

        slider.addEventListener('touchmove', function(e) {
          if (!isDown || !e.touches[0]) return;
          if (isInside(e.touches[0].clientX)) {
            e.preventDefault();
            updateSlider(e.touches[0].clientX);
          }
        }, { passive: false });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSliders);
    } else {
      initSliders();
    }
    document.addEventListener('shopify:section:load', initSliders);
  })();

  } catch(e) { console.error(e); }
})();
})();
